import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, CircularProgress } from '@mui/material';
import Navbar from '../components/Navbar';

const NotFound = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  // Read Role and Organization from localStorage
  const Role = localStorage.getItem('Role');
  const Organization = localStorage.getItem('Organization');

  useEffect(() => {
    // Redirect logic for 404
    if (Role === "SuperAdmin") {
      navigate("/overview", { replace: true });
      window.location.reload();
    } else if (!Organization) {
      navigate("/create-company", { replace: true });
      window.location.reload();
    } else {
      navigate(`/company/${Organization}/overview`, { replace: true });
      window.location.reload();
    }
    setLoading(false);
    // eslint-disable-next-line
  }, [Role, Organization, navigate]);

  // Show loading while redirecting
  if (loading) {
    return (
      <Box sx={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
        <Navbar title="Redirecting..." />
        <Box sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: '#fff'
        }}>
          <CircularProgress />
          <Typography sx={{ mt: 2 }}>Redirecting to the right page...</Typography>
        </Box>
      </Box>
    );
  }

  // Fallback 404 UI (should rarely appear)
  return (
    <Box sx={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
      <Navbar title="Page Not Found" />
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%',
          backgroundColor: '#fff',
          overflow: 'hidden',
          flexDirection: 'column',
        }}
      >
        <Box
          sx={{
            width: '100px',
            height: '100px',
            backgroundColor: '#02042D',
            borderRadius: '50%',
            margin: '0 auto 2rem',
            animation: 'float 2s ease-in-out infinite',
          }}
        ></Box>
        <Box sx={{ marginBottom: '1rem', textAlign: 'center' }}>
          <Typography
            variant="h2"
            sx={{
              fontSize: '3rem',
              fontWeight: 'bold',
              margin: '0 0 1rem',
              color: '#333',
            }}
          >
            404 error
          </Typography>

          <Typography
            variant="h5"
            sx={{
              fontSize: '2rem',
              fontWeight: 'lighter',
              margin: '0 0 1.5rem',
              color: '#555',
            }}
          >
            It looks like you’ve taken a wrong turn.
          </Typography>
        </Box>
      </Box>
      <style>{`
        @keyframes float {
          0% { transform: translateY(0); }
          50% { transform: translateY(-20px); }
          100% { transform: translateY(0); }
        }
      `}</style>
    </Box>
  );
};

export default NotFound;
